import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, greaterThan, Theme } from 'localmed-core';
import * as React from 'react';
import Media from 'react-media';
import { useLocation } from 'react-router';
import LeafletMap from '../../../shared/components/LeafletMap';
import { buildOfficeSchedulingUrl } from '../../../shared/utils/urls';
import { Office } from '../OfficeListMapV2/types';

interface PracticePageMapContainerProps {
  v2?: boolean;
}

const PracticePageMapContainer = styled(Box)<PracticePageMapContainerProps, Theme>(
  () => css`
    background: #ddd;
    height: 150px;
  `,
  greaterThan(
    'lg',
    ({ v2 }: PracticePageMapContainerProps & { theme: Theme }) => css`
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: ${v2 ? '30px' : '50px'};
      z-index: 1;
      height: auto;
    `
  )
);

// TODO: Pull this type from Leaflet
export type Viewport = { center: [number, number]; zoom: number };

interface OfficeMapProps {
  activeOffice: Office | null;
  onOfficeHover: (office: Office | null) => void;
  offices: Office[];
  v2?: boolean;
  // TODO: Type the LeafletMap component and inherit these props
  hasZoomControl?: boolean;
  viewport?: Viewport | null;
  onViewportChanged?: (viewport: Viewport | null) => void;
}

export default function OfficeMap({
  offices,
  activeOffice,
  onOfficeHover,
  v2,
  ...props
}: OfficeMapProps) {
  const location = useLocation();
  const markers = offices.map((office) => ({
    id: office.id,
    href: buildOfficeSchedulingUrl(office.id, { location }),
    latitude: office.latitude,
    longitude: office.longitude,
  }));
  return (
    <Media query="(min-width: 800px)">
      {(isDesktop) => (
        <PracticePageMapContainer v2={v2}>
          <LeafletMap
            markers={markers}
            activeMarker={activeOffice}
            onMarkerHover={(marker: any) => {
              if (marker != null) {
                onOfficeHover(offices.find((office) => marker.id === office.id) ?? null);
              } else {
                onOfficeHover(null);
              }
            }}
            {...props}
            boundsOptions={{
              paddingTopLeft: isDesktop ? [448, 98] : [24, 48],
              paddingBottomRight: [24, 24],
              maxZoom: 15,
            }}
            height="100%"
            v2={v2}
          />
        </PracticePageMapContainer>
      )}
    </Media>
  );
}
